
export const defaultTenant = "";